import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { mockListings } from '../../mockData';
import './Pages.css';

function ListingDetailPage({ isLoggedIn }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bidAmount, setBidAmount] = useState('');
  
  // Find the listing details
  const listing = mockListings.find(item => item.id === id);
  
  // Handle if listing not found
  if (!listing) {
    return (
      <div className="page listing-detail-page">
        <div className="not-found">
          <h1>Listing Not Found</h1>
          <p>The listing you're looking for doesn't exist or has been removed.</p>
          <Link to="/browse" className="btn-primary">Browse Other Listings</Link>
        </div>
      </div>
    );
  }
  
  // Find similar items
  const similarItems = listing.similarItems ? 
    listing.similarItems.map(itemId => mockListings.find(item => item.id === itemId)).filter(Boolean) : 
    [];
  
  // Format end time for auctions
  const formatEndTime = (endTimeStr) => {
    const endTime = new Date(endTimeStr);
    return endTime.toLocaleString('en-HK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  // Handle contact seller button
  const handleContactSeller = () => {
    if (!isLoggedIn) {
      alert("Please login to contact seller");
      navigate('/login');
    } else {
      // In a real app, we would create a new chat or use an existing one
      navigate('/chat/chat001');
    }
  };
  
  // Handle place bid button
  const handlePlaceBid = (e) => {
    e.preventDefault();
    
    if (!isLoggedIn) {
      alert("Please login to place a bid");
      navigate('/login');
      return;
    }
    
    if (!bidAmount || isNaN(bidAmount) || parseFloat(bidAmount) <= listing.currentBid) {
      alert(`Bid must be higher than the current bid of HK$${listing.currentBid}`);
      return;
    }
    
    // Navigate to payment gateway with auction bid data
    navigate('/payment', {
      state: {
        paymentType: 'auction',
        amount: bidAmount,
        itemId: listing.id,
        title: listing.title,
        returnPath: `/listing/${listing.id}`
      }
    });
  };
  
  return (
    <div className="page listing-detail-page">
      <div className="listing-detail-container">
        <div className="listing-image-container">
          <img src={listing.imageUrl} alt={listing.title} className="listing-detail-image" />
          {listing.isAuction && (
            <div className="auction-badge-large">Auction</div>
          )}
        </div>
        
        <div className="listing-info-container">
          <h1 className="listing-detail-title">{listing.title}</h1>
          
          <div className="listing-detail-price">
            {listing.isAuction 
              ? `Current Bid: HK$${listing.currentBid}`
              : `HK$${listing.price}`
            }
          </div>
          
          <div className="listing-detail-meta">
            <div className="listing-detail-condition">
              <span className="meta-label">Condition:</span> {listing.condition}
            </div>
            <div className="listing-detail-location">
              <span className="meta-label">Location:</span> {listing.location}
            </div>
            <div className="listing-detail-seller">
              <span className="meta-label">Seller:</span> 
              <Link to={`/profile/${listing.sellerId}`} className="seller-link">
                {listing.sellerUsername}
              </Link>
            </div>
          </div>
          
          {listing.isAuction && (
            <div className="auction-details">
              <div className="auction-end-time">
                <span className="meta-label">Ends:</span> {formatEndTime(listing.endTime)}
              </div>
              
              <form className="bid-form" onSubmit={handlePlaceBid}>
                <div className="bid-input-container">
                  <label htmlFor="bid-amount">Your Bid (HK$):</label>
                  <input
                    type="number"
                    id="bid-amount"
                    className="bid-input"
                    value={bidAmount}
                    onChange={(e) => setBidAmount(e.target.value)}
                    min={listing.currentBid + 1}
                    step="1"
                    placeholder={`Min: HK$${listing.currentBid + 1}`}
                    required
                  />
                </div>
                <button 
                  type="submit" 
                  className="place-bid-button"
                  disabled={!isLoggedIn}
                >
                  Place Bid
                </button>
              </form>
            </div>
          )}
          
          <button 
            className="contact-seller-button" 
            onClick={handleContactSeller}
          >
            Contact Seller
          </button>
        </div>
      </div>
      
      <div className="listing-description-container">
        <h2 className="description-title">Description</h2>
        <p className="listing-description">{listing.description}</p>
      </div>
      
      {similarItems.length > 0 && (
        <div className="similar-items-container">
          <h2 className="similar-items-title">Similar Items</h2>
          <div className="similar-items-grid">
            {similarItems.map(item => (
              <Link to={`/listing/${item.id}`} key={item.id} className="similar-item-card">
                <div className="similar-item-image">
                  <img src={item.imageUrl} alt={item.title} />
                </div>
                <div className="similar-item-info">
                  <h3 className="similar-item-title">{item.title}</h3>
                  <div className="similar-item-price">
                    {item.isAuction 
                      ? `Current Bid: HK$${item.currentBid}`
                      : `HK$${item.price}`
                    }
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ListingDetailPage; 